import { DateUtil, LogManager, ModelRow } from "@mcleod/core";
import { AutogenLayoutCollections } from "./autogen/AutogenLayoutCollections";
import { LMEUserSettings } from "@mcleod/general";
import { ModelCollectionsProfile, RowCollectionsProfile } from "./models/ModelCollectionsProfile";
import { DataSourceAction, DataSourceExecutionEvent, Snackbar, Table } from "@mcleod/components";
import { FilterPanel } from "@mcleod/dispatch";

const log = LogManager.getLogger("lme.ar.Collections");

export interface CollectionsTableLayout {
    selectedCustomerRow: ModelRow;
    tableCollections: Table;
    filterPanel: FilterPanel;
    getProfileRow: () => RowCollectionsProfile;
    updateTableFooter: () => void;
}

export class Collections extends AutogenLayoutCollections {
    private _profileRow: RowCollectionsProfile;

    override onLoad() {
        this.layoutCollectionsTable.getProfileRow = () => this.profileRow;
    }

    // Called from MultiProfilePlanningTabs.ts
    async loadProfile(profile?: string | ModelRow) {
        log.debug("Loading profile");
        if (profile instanceof ModelRow) {
            this.setProfileRow(profile);
            return;
        }

        const profileId = profile ?? LMEUserSettings.get()?.collections_profile;
        if (profileId) {
            const profileRow = await new ModelCollectionsProfile().searchSingle({ id: profileId });
            if (profileRow) {
                log.debug("Collections Profile", profileRow);
                this.setProfileRow(profileRow);
            } else {
                Snackbar.showSnackbar("The profile [" + profileId + "] was not found. ", { persist: true });
            }
        } else {
            Snackbar.showSnackbar("You do not have a default collections profile defined. "
                + "Add a default profile to your preferences so your collections will automatically "
                + "display, or you can select a profile above to get started.", { persist: true }
            );
        }
    }

    public get profileRow(): RowCollectionsProfile {
        return this._profileRow;
    }

    public setProfileRow(value: ModelRow) {
        if (value != this._profileRow) {
            this._profileRow = value as RowCollectionsProfile;
            if (this.profileRow) {
                this.searchDataSource();
            }
        }
    }

    private async searchDataSource() {
        this.layoutGroupBy.tableGroupBy.busy = true;
        this.layoutCollectionsTable.tableCollections.busy = true;
        await this.mainDataSource.search({ profile_row: this.profileRow });
    }

    async sourceCollectionsAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() == DataSourceAction.SEARCH) {
            await this.layoutGroupBy.initialize(this.layoutCollectionsTable);
            this.labelLastRefreshDateTime.text = DateUtil.formatDateTime(new Date());
            this.layoutGroupBy.tableGroupBy.busy = false;
            this.layoutCollectionsTable.tableCollections.busy = false;
        }
    }

    async buttonRefreshOnClick() {
        await this.searchDataSource();
    }
}
